import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { HeaderComponent } from "./header/header.component";

@Component({
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: true,
    imports:[HeaderComponent,RouterOutlet]
})

export class MainComponent implements OnInit {


  public ngOnInit(): void {
  }
  public CloseMenu(){
    const menu = document.getElementsByClassName("sidebar-menu").item(0) as HTMLElement;
    menu.className = "sidebar-menu";
  }

}
